// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"517":"21a8632b","787":"42389517","866":"2cb1051b","885":"2dcaacde"}[chunkId] + ".chunk.js";
};